<template>
  <div class="page page-mask">
    <svg v-if="!isIE11" class="page-mask--back" viewBox="0 0 1290 310">
      <g transform="translate(-941 -800)">
        <path d="M1190.5,1023.703c-109.862,10.075-250,24.072-250,24.072v-255H2232
          c0,0,0.291,18.755,0,25.999c-0.13,3.229-0.869,13.808-1.125,15.876c-5.375,43.375-51.875,77.125-100.954,86.004
          c-72.424,13.102-146.711,23.192-291.921,38.121C1676.246,975.405,1414.353,1003.174,1190.5,1023.703z"/>
        <path d="M940.5,1068.775v64.53H2232c0,0,0-7.621,0-24.03
          c0-3.049-0.498-11.564-1.167-15c-8.333-42.833-69.809-73.923-96.833-84.336c-67.25-25.914-143.471-27.654-175.002-27.547
          C1701.605,983.264,940.5,1068.775,940.5,1068.775z"/>
      </g>
    </svg>
    <img v-else class="page-mask--back" src="/static/masks/mask-2.png"/>
  </div>
</template>

<script>
import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],
};
</script>



// WEBPACK FOOTER //
// src/components/Masks/Mask2.vue